import { render, staticRenderFns } from "./AdminStudentReport.vue?vue&type=template&id=5b823450"
import script from "./AdminStudentReport.vue?vue&type=script&lang=js"
export * from "./AdminStudentReport.vue?vue&type=script&lang=js"
import style0 from "./AdminStudentReport.vue?vue&type=style&index=0&id=5b823450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports